/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Red_Ocelot_FeelInputs */

const en_kind_red_ocelot_feel = /** @type {(inputs: Kind_Red_Ocelot_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No segment selectors found`)
};

const de_kind_red_ocelot_feel = /** @type {(inputs: Kind_Red_Ocelot_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Segment-Selektoren gefunden`)
};

/**
* | output |
* | --- |
* | "No segment selectors found" |
*
* @param {Kind_Red_Ocelot_FeelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_red_ocelot_feel = /** @type {((inputs?: Kind_Red_Ocelot_FeelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Red_Ocelot_FeelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_red_ocelot_feel(inputs)
	return de_kind_red_ocelot_feel(inputs)
});